import { Result } from 'antd'
import { useHistory } from 'react-router-dom'
import Button from '../Components/Button'

function NotFound() {
  const history = useHistory()

  return (
    <div className="page-not-found">
      <div>
        <Result
          status="404"
          title="Page Not Found"
          extra={
            <Button variant="primary" onClick={() => history.push('/app/dashboard')}>
              Go to Home
            </Button>
          }
        />
      </div>
    </div>
  )
}

export default NotFound
